import type { IconName } from '../../design/Icon';

/**
 * Registre des types d'Item (CLAUDE.md §9) : chaque module y déclare ses types. Le socle ne connaît le
 * contenu d'aucun type ; il sait seulement comment les présenter (service, libellé, icône) dans les
 * sélecteurs de lien et les rétroliens. Un `type` inconnu s'affiche comme non supporté, sans modification.
 */
export interface ItemTypeInfo {
  type: string;
  /** Service qui porte ce type (« Notes », « Vault »…). */
  service: string;
  typeLabel: string;
  icon: IconName;
}

const types = new Map<string, ItemTypeInfo>();

export function registerItemType(info: ItemTypeInfo): void {
  types.set(info.type, info);
}

export function itemTypeInfo(type: string): ItemTypeInfo {
  return types.get(type) ?? { type, service: 'Autre', typeLabel: 'Objet', icon: 'doc' };
}

export const isKnownItemType = (type: string): boolean => types.has(type);

export function registeredServices(): string[] {
  return [...new Set([...types.values()].map((t) => t.service))];
}
